<template>
  <ItemListCollectionWrapper
    :collectionModule="$options.sharedFolderGroupCollection"
    defaultSortBy="email"
    :refreshKey="refreshKey"
    :rowsPerPageLocalStorageKey="$options.rowsPerPageLocalStorageKey"
  >
    <template
      v-slot="slotProps"
    >
      <ItemListPagination
        :columns="$options.columns"
        :currentPageNum="slotProps.currentPageNum"
        :isLoading="slotProps.loading"
        :itemComponent="$options.SharedFolderGroupRow"
        :rowsPerPage="slotProps.rowsPerPage"
        :showEmptyState="!slotProps.loading && slotProps.showEmptyState"
        :sortBy="slotProps.sortBy"
        :sortDirection="slotProps.sortDirection"
        :tableData="slotProps.tableData"
        :totalCount="slotProps.totalCount"
        @pageChange="slotProps.handlePageChange"
        @sortColumn="slotProps.handleSortColumn"
      >
        <template
          v-slot:toolbar
        >
          <SharedFolderGroupsToolbar
            :searchTerm="slotProps.getSearchTerm"
            :shouldFocusSearch="slotProps.shouldFocusSearch"
            @triggerSearch="slotProps.handleEnterSearchTerm"
          />
        </template>
        <template
          v-slot:emptyState
        >
          <NoSearchResults
            :src="$options.noResultsIllustration"
            @click="slotProps.clearSearchTerm"
          />
        </template>
      </ItemListPagination>
    </template>
  </ItemListCollectionWrapper>
</template>

<script>
import {
  ItemListPagination,
  NoSearchResults,
  Types,
} from '@jumpcloud/ui-components';
import { mapActions, mapGetters } from 'vuex';
import Constants, {
  LocalStorageConsts,
} from 'client/util/Constants';
import ItemListCollectionWrapper from 'client/components/ItemList/ItemListCollectionWrapper.vue';
import SharedFolderGroupRow from 'client/PasswordManager/SharedFolders/SharedFolderGroupRow.vue';
import SharedFolderGroupsToolbar from 'client/PasswordManager/SharedFolders/SharedFolderGroupsItemListToolbar.vue';

const { noResultsIllustration } = Constants;
const sharedFolderGroupCollection = 'SharedFolderGroupCollection';

const { Column } = Types;
const columns = [
  Column({
    label: 'Name',
    dataFieldName: 'name',
    sortable: true,
    width: '1fr',
  }),
  Column({
    label: 'User Count',
    dataFieldName: 'usersCount',
    sortable: true,
    width: '1fr',
  }),
  Column({
    label: 'Access Level',
    dataFieldName: 'accessLevelName',
    sortable: false,
    width: '1fr',
  }),
  Column({
    label: '',
    sortable: false,
    width: '1fr',
  }),
];

export default {
  name: 'SharedFolderGroupsItemList',

  components: {
    ItemListPagination,
    ItemListCollectionWrapper,
    NoSearchResults,
    SharedFolderGroupsToolbar,
  },

  columns,
  noResultsIllustration,
  SharedFolderGroupRow,
  sharedFolderGroupCollection,
  rowsPerPageLocalStorageKey: LocalStorageConsts.sharedFolderGroupsRowsPerPage,

  props: {
    sharedFolderId: {
      default: '',
      type: String,
    },
  },

  computed: {
    ...mapGetters(sharedFolderGroupCollection, [
      'refreshKey',
    ]),
  },

  destroyed() {
    this.resetSharedFoldersGroups();
  },

  created() {
    this.setSharedFolderId(this.sharedFolderId);
  },

  methods: {
    ...mapActions(sharedFolderGroupCollection, [
      'setSharedFolderId',
      'resetSharedFoldersGroups',
    ]),
  },
};
</script>
